(function () {
  'use strict';

  const angular = window.angular;

  const STRONG_PASSWORD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9]).{8,}$/;

  Controller.$inject = ['AppUtils', 'UserService', 'LoopBackAuth'];

  angular.module('app').component('forcePasswordChangePage', {
    template:'<section class="login-container"><div class="login-header"><div class="login-brand"></div><h3 class="no-margin" translate>views.public.changePass.title</h3></div><div class="login-content text-center" ng-if="ctrl.success"><h4 class="text-success"><i class="far fa-check-circle fa-fw fa-2x"></i> <strong style="display: block" class="marginTB10" translate>views.public.changePass.changedPass</strong></h4><p class="marginB20 paddingB20" translate>views.public.changePass.message</p><div class="text-center marginT20"><a ui-sref="public.login" translate>buttons.signin</a></div></div><div class="login-content" ng-if="!ctrl.success"><p class="text-center marginB20" translate>entities.user.password.mustChangePasswordInfo</p><form name="ctrl.changePasswordForm" novalidate class="login-form validate" ng-submit="ctrl.changePassword()"><div class="form-group" show-errors><div class="input-group"><span class="input-group-addon"><i class="fas fa-key fa-fw"></i></span> <input ng-model="ctrl.form.password" ng-change="ctrl.onPasswordChange()" ng-blur="ctrl.onBlur()" type="password" class="form-control" name="password" required translate-attr="::{placeholder: \'entities.user.password.new\'}"></div><p ng-messages="ctrl.changePasswordForm.password.$error" class="help-block" role="alert"><span ng-message="required" translate>form.errors.required</span> <span ng-message="weak" translate>entities.user.password.weak</span> <span ng-message="password_mismatch" translate>form.errors.passwordMismatch</span></p></div><div class="form-group" show-errors><div class="input-group"><span class="input-group-addon"><i class="fas fa-key fa-fw"></i></span> <input ng-model="ctrl.form.repeatPassword" ng-change="ctrl.onPasswordChange()" ng-blur="ctrl.onBlur()" type="password" class="form-control" name="repeatPassword" required translate-attr="::{placeholder: \'entities.user.password.confirmNew\'}"></div><p ng-messages="ctrl.changePasswordForm.repeatPassword.$error" class="help-block" role="alert"><span ng-message="required" translate>form.errors.required</span> <span ng-message="password_mismatch" translate>form.errors.passwordMismatch</span></p></div><ul class="list-unstyled marginB20" style="font-size: 12px"><li ng-class="ctrl.requirements.length ? \'text-success\' : \'text-muted\'"><i class="fas fa-fw" ng-class="ctrl.requirements.length ? \'fa-check-circle\' : \'fa-circle\'"></i> <span translate>entities.user.password.reqLength</span></li><li ng-class="ctrl.requirements.upper ? \'text-success\' : \'text-muted\'"><i class="fas fa-fw" ng-class="ctrl.requirements.upper ? \'fa-check-circle\' : \'fa-circle\'"></i> <span translate>entities.user.password.reqUpper</span></li><li ng-class="ctrl.requirements.lower ? \'text-success\' : \'text-muted\'"><i class="fas fa-fw" ng-class="ctrl.requirements.lower ? \'fa-check-circle\' : \'fa-circle\'"></i> <span translate>entities.user.password.reqLower</span></li><li ng-class="ctrl.requirements.digit ? \'text-success\' : \'text-muted\'"><i class="fas fa-fw" ng-class="ctrl.requirements.digit ? \'fa-check-circle\' : \'fa-circle\'"></i> <span translate>entities.user.password.reqDigit</span></li><li ng-class="ctrl.requirements.symbol ? \'text-success\' : \'text-muted\'"><i class="fas fa-fw" ng-class="ctrl.requirements.symbol ? \'fa-check-circle\' : \'fa-circle\'"></i> <span translate>entities.user.password.reqSymbol</span></li></ul><div class="alert alert-warning no-margin text-center marginB20" ng-show="ctrl.saveError">{{ctrl.saveError}}</div><button class="btn btn-login btn-lg btn-block" ng-disabled="ctrl.saving" translate>buttons.save</button></form></div><spinner css-class="\'small\'" show-logo="true" show="ctrl.saving"></spinner></section>',
    controller: Controller,
    controllerAs: 'ctrl',
  });

  function Controller(utils, UserService, LoopBackAuth) {
    const vm = this;

    vm.$onInit = function () {
      vm.form = {};
      vm.requirements = { length: false, upper: false, lower: false, digit: false, symbol: false };

      vm.onPasswordChange = onPasswordChange;
      vm.onBlur = onBlur;
      vm.changePassword = changePassword;
    };

    function onPasswordChange() {
      let password = vm.form.password || '';
      let repeatPassword = vm.form.repeatPassword || '';

      vm.requirements.length = password.length >= 8;
      vm.requirements.upper = /[A-Z]/.test(password);
      vm.requirements.lower = /[a-z]/.test(password);
      vm.requirements.digit = /\d/.test(password);
      vm.requirements.symbol = /[^A-Za-z0-9]/.test(password);

      if (!password || !repeatPassword || password === repeatPassword) {
        vm.changePasswordForm.password.$setValidity('password_mismatch', true);
        vm.changePasswordForm.repeatPassword.$setValidity('password_mismatch', true);
      }
      vm.changePasswordForm.password.$setValidity('weak', true);
    }

    function onBlur() {
      let password = vm.form.password || '';
      let repeatPassword = vm.form.repeatPassword || '';
      let matches = !password || !repeatPassword || password === repeatPassword;
      vm.changePasswordForm.password.$setValidity('password_mismatch', matches);
      vm.changePasswordForm.repeatPassword.$setValidity('password_mismatch', matches);
    }

    function changePassword() {
      let password = vm.form.password;
      let repeatPassword = vm.form.repeatPassword;
      if (password !== repeatPassword) {
        vm.changePasswordForm.password.$setValidity('password_mismatch', false);
        vm.changePasswordForm.repeatPassword.$setValidity('password_mismatch', false);
      }

      vm.changePasswordForm.password.$setValidity('weak', STRONG_PASSWORD_REGEX.test(password || ''));

      if (!vm.changePasswordForm.$valid) {
        return;
      }

      vm.saving = true;
      vm.saveError = null;
      UserService
        .setPassword(LoopBackAuth.currentUserId, password)
        .then(() => {
          vm.saving = false;
          // setPassword invalidates every access token for this user,
          // including the reset-password token used by this screen.
          LoopBackAuth.clearUser();
          LoopBackAuth.clearStorage();
          vm.success = true;
        })
        .catch((err) => {
          vm.saving = false;
          vm.saveError = utils.getHTTPError(err);
        });
    }
  }
})();
